import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M21.938 2.25v11.375a2.19 2.19 0 0 1-2.188 2.188H9.35a1.312 1.312 0 0 1-1.904 1.803L5.26 15.43a1.31 1.31 0 0 1 0-1.86l2.187-2.187a1.312 1.312 0 0 1 1.905 1.806h9.962v-10.5H7.938a1.313 1.313 0 1 1-2.625 0V2.25A2.19 2.19 0 0 1 7.5.063h12.25a2.187 2.187 0 0 1 2.188 2.187M15.375 18a1.313 1.313 0 0 0-1.312 1.313H2.688v-10.5h9.961a1.313 1.313 0 0 0 1.905 1.803L16.74 8.43a1.313 1.313 0 0 0 0-1.86l-2.187-2.187a1.313 1.313 0 0 0-1.905 1.806H2.25A2.19 2.19 0 0 0 .063 8.375V19.75a2.187 2.187 0 0 0 2.187 2.188H14.5a2.19 2.19 0 0 0 2.188-2.188v-.437A1.313 1.313 0 0 0 15.375 18"
    }, null, -1)
  ])))
}
export default { render: render }